<template>
  <div class="page-error">
    <img :src="require('./403.png')" />
    <!-- <p class="code">403</p> -->
    <p class="error">需要配置权限才能访问{{moduleTitle}}</p>
    <div style="margin-top: 28px;">
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
 import { importRemote, getSubModuleName, getMatchedModule } from '../../router/remote/index.js'
 const ModuleDefalutTitle = '该页面'
 export default {
  data () {
    return {
      moduleTitle: ModuleDefalutTitle,
      routePath: '/'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.routePath = from.fullPath
    })
  },
  mounted () {
    this.getSubModuleTitle()
  },
  methods: {
    goBack () {
      // 解决返回路由页面时layout 为 false 页面刷新的问题
      const routePath = this.routePath
      const currentRoute = this.$store.state.tagsView.visitedViews.find(t => t.path === routePath)
      if (routePath !== '/' && currentRoute) {
        const currentPathRoute = this.$router.resolve(routePath).route
        currentPathRoute && (currentPathRoute.meta.layout = true)
      }
      this.$router.erpReplace(routePath)
    },
    getSubModuleTitle () {
      try {
        this.moduleTitle = ModuleDefalutTitle
        const routerTo = this.$route.params && this.$route.params.to
        if (!routerTo || !routerTo.path) return
        // 路由表中有该路由信息或本地开发时服务中包含的路由信息
        if (routerTo.meta && routerTo.meta.title) {
          this.moduleTitle = routerTo.meta.title
        } else {
          // 查找路由对应的仓库
          const moduleName = getSubModuleName(routerTo)
          const projectName = getMatchedModule(moduleName)
          // 通过加载仓库中的远程组件来获取远程组件前需要的仓库的路由信息
          new Promise(importRemote(`${projectName.name}/xxxxx`, this.$router)).then(function(res) {
            console.log('res', res)
          }).finally(e => {
            const menuRouter = this.$router.matcher.match(routerTo.path)
            this.moduleTitle = (menuRouter && menuRouter.meta && menuRouter.meta.title) || ModuleDefalutTitle
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
 }
</script>

<style lang='scss'>
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/layout/layout/error-page/403.vue